import { Button, Modal } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
const ApplicationIncomplete = ({ title, closeModal, isOpen, onProceed, warning }) => {
    const { t } = useTranslation();
    return (<Modal open={isOpen} size="md" heading={title} onClose={closeModal} footer={<div className="flex md:flex-row justify-end flex-col gap-2">
                    <Button onClick={onProceed} variant="critical" label={t('financing.application_incomplete.leave')}/>
                    <Button variant="primary" onClick={closeModal} label={t('financing.application_incomplete.stay_continue')}/>
                </div>}>
            <p className="text-neutral-secondary-initial body-m">{warning}</p>
        </Modal>);
};
export default ApplicationIncomplete;
